import apiClient from "./api";
import axios from "axios";

export interface GenerateUploadUrlData {
  fileType: string;
  categoryId?: string; // For subcategory/type context
  subcategoryId?: string; // For type context
}

export interface GenerateUploadUrlResponse {
  message: string;
  data: {
    uploadUrl: string;
    imageUrl: string;
    key: string;
  };
  timestamp: string;
}

export interface ConfirmUploadData {
  categoryID: string;
  imageUrl: string;
}

export interface ConfirmUploadResponse {
  success: boolean;
  message: string;
}

export const adminImageService = {
  /**
   * Generate pre-signed S3 upload URL
   */
  generateUploadUrl: async (data: GenerateUploadUrlData): Promise<GenerateUploadUrlResponse> => {
    const response = await apiClient.post<GenerateUploadUrlResponse>(
      `/categories-catalogue/generate-upload-url`,
      data
    );
    return response.data;
  },

  /**
   * Upload image directly to S3 using pre-signed URL
   */
  uploadToS3: async (uploadUrl: string, file: File): Promise<void> => {
    // Upload directly to S3 (not through our API)
    await axios.put(uploadUrl, file, {
      headers: {
        "Content-Type": file.type,
      },
    });
  },

  /**
   * Confirm upload and save image URL to category
   */
  confirmUpload: async (
    data: ConfirmUploadData
  ): Promise<ConfirmUploadResponse> => {
    const response = await apiClient.post<ConfirmUploadResponse>(
      "/category/confirm-upload",
      data
    );
    return response.data;
  },
};
